import React, { JSX } from 'react'
import { GoArrowDownRight, GoArrowUpRight } from 'react-icons/go'
import { PiDotsThreeCircleVerticalLight } from 'react-icons/pi'

import { BodyMeasurement } from '../api/services/dd_panel_body_measurements/types.ts'

export type BodyMeasurementsTableColumn = {
  header: string
  accessor: string
  render?: (data: BodyMeasurement) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean

  // nowe pola dla formularza
  showInForm?: boolean
  inputType?: 'text' | 'number' | 'date'
  required?: boolean
  hideInForm?: boolean
  formLabel?: string
}

export const setBodyMeasurementsTableColumns = (formAvailable?: boolean) => {
  const columns: BodyMeasurementsTableColumn[] = [
    {
      header: 'Data pomiaru',
      formLabel: 'Data pomiaru*',
      accessor: 'measured_at',
      inputType: 'date',
      required: true,
      render: (row: BodyMeasurement) => (
        <p className={'text-xm'}>{row.measured_at}</p>
      ),
      className: 'w-[140px]'
    },
    {
      header: 'Waga (kg)',
      formLabel: 'Waga (kg)*',
      accessor: 'bm',
      inputType: 'number',
      required: true,
      render: (row: BodyMeasurement) => (
        <p className={'text-xm'}>{Number(row.bm).toFixed(1)}</p>
      ),
      className: 'w-[120px]'
    },
    {
      header: 'Zmiana Wagi',
      accessor: 'previousWeight',
      hideInForm: true,
      render: (row: BodyMeasurement) => {
        const previousWeight = Number(row.previousWeight)
        const bm = Number(row.bm)
        const result = Math.round((bm - previousWeight) * 10) / 10
        const withSign = result < 0 ? '' : '+'

        return (
          <p className={'flex flex-row text-xm'}>
            {result !== 0 ? `${withSign}${result} kg` : ''}
            {result !== 0 ? (
              result < 0 ? (
                <GoArrowDownRight color={'#008700'} size={20} />
              ) : (
                <GoArrowUpRight color={'#F00'} size={20} />
              )
            ) : (
              ''
            )}
          </p>
        )
      },
      className: 'w-[150px] 2xl:w-auto'
    },
    {
      header: 'Wzrost (cm)',
      formLabel: 'Wzrost (cm)*',
      accessor: 'bh',
      inputType: 'number',
      required: true,
      render: (row: BodyMeasurement) => (
        <p className={'text-xm'}>{Number(row.bh).toFixed(1)}</p>
      ),
      className: 'w-[150px] 2xl:w-auto'
    },
    {
      header: 'BMI',
      formLabel: 'BMI*',
      accessor: 'bmi',
      inputType: 'number',
      showInForm: true,
      required: true,
      render: (row: BodyMeasurement) => (
        <p className={'text-xm'}>{Number(row.bmi).toFixed(1)}</p>
      ),
      className: 'w-[150px] 2xl:w-auto'
    }
  ]

  // for formAvailable all details display in the table
  if (formAvailable) {
    columns.push(
      {
        header: 'Tkanka tł.',
        formLabel: 'Tkanka tłuszczowa',
        accessor: 'bfp',
        inputType: 'number',
        showInForm: true,
        required: false,
        render: (row: BodyMeasurement) => (
          <p className={'text-xm'}>
            {row.bfp && row.bfp !== '0.00' ? `${Number(row.bfp).toFixed(1)} %` : '-'}
          </p>
        ),
        className: 'w-[150px] 2xl:w-auto'
      },
      {
        header: 'Woda',
        formLabel: 'Woda',
        accessor: 'water',
        inputType: 'number',
        showInForm: true,
        required: false,
        render: (row: BodyMeasurement) => (
          <p className={'text-xm'}>
            {row.water && row.water !== '0.0' ? `${Number(row.water).toFixed(1)} %` : '-'}
          </p>
        ),
        className: 'w-[150px] 2xl:w-auto'
      }
    )
  }

  columns.push({
    header: 'Dodający',
    accessor: 'created_by_dietitian',
    showInForm: false,
    required: false,
    render: (row: BodyMeasurement) => (
      <p className={'text-xm'}>
        {row.created_by_dietitian ? (
          <span
            className={
              'inline-flex max-w-full min-w-0 rounded-xl py-1 px-2 bg-green-600 text-white'
            }
          >
            Dietetyk
          </span>
        ) : (
          <span className={'px-2'}>Pacjent</span>
        )}
      </p>
    ),
    className: 'w-[120px]'
  })

  return columns
}

export const setBodyMeasurementsTableActions = (
  onOpenMenu: (
    row: BodyMeasurement,
    event: React.MouseEvent<HTMLButtonElement>
  ) => void,
  hideMenuForAll: boolean
) => {
  return [
    {
      label: '',
      icon: <PiDotsThreeCircleVerticalLight size={30} />,
      onClick: (
        row: BodyMeasurement,
        event: React.MouseEvent<HTMLButtonElement>
      ) => {
        onOpenMenu(row, event)
      },
      className: 'text-blue-500 pb-1',
      visible: (row: BodyMeasurement) => {
        return hideMenuForAll ? !hideMenuForAll : row.created_by_dietitian
      }
    }
  ]
}
